// Vendor Libs
import React from 'react';

// Material UI Icons
import Cloud from '@material-ui/icons/Cloud';

// Styles
import './no-match.scss';

const NoMatch = () => (
    <section className="no-match">
        <h2>The requested page could not be found</h2>
        <div className="no-match--background">
            <Cloud className="no-match--background-cloud" />
            <Cloud className="no-match--background-cloud" />
        </div>
    </section>
);

export default NoMatch;
